/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { DynamicIconProps } from '../../../icon/icon.types';
import { Icon } from '../../icon';

const Profile24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Profile 24">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M5 9a7 7 0 1 1 14 0A7 7 0 0 1 5 9Zm10.995 8.067a9 9 0 1 0-7.99 0A7.997 7.997 0 0 0 4 24h2a6 6 0 0 1 12 0h2a7.997 7.997 0 0 0-4.005-6.933ZM10 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        className="SVG"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: Profile24,
  md: Profile24,
  lg: Profile24,
  xl: Profile24,
  xxl: Profile24,
  xxxl: Profile24,
};

export const ProfileIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: DynamicIconProps) => {
  return (
    <Icon
      data-testid={testId || 'profile-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
